import axios from 'axios';
import {ApiPathRESE } from '../../../common/api-path/ApiPath';

export default class ReseFileuploadService {

    async getFileTypes() {
        const response = await axios.get(`${ApiPathRESE.baseUrl}/getUseCase`, { timeout: 120000, timeoutErrorMessage: "request timeout" });
        if(response.status >= 400) {
            throw new Error(response.errors);
        }
        return response.data;
    }
    
    bulkUpload(data, selectedFileTypeName, snowTicketNumber, description,store) {
        const getHeaders = () => {
            // Conditionally return headers
            if (selectedFileTypeName === "Energy Meter") {
              return {
                'Usecase': 'FileUpload.EnergyMeter'
              };
            }
            else if (selectedFileTypeName === "User"){
                return {
                    'Usecase': 'FileUpload.AddUser'
                  };
            }
            else if (selectedFileTypeName === "BMS"){
                return {
                    'Usecase': 'FileUpload.AddBMS'
                  };
            }
            else if (selectedFileTypeName === "Store"){
                return {
                    'Usecase': 'FileUpload.AddBMSStore'
                  };
            }
            else if (selectedFileTypeName === "Bms Brand"){
                return {
                    'Usecase': 'FileUpload.AddBMSBrand'
                  };
            }
            else if (selectedFileTypeName === "Driver Configuration"){
                return {
                    'Usecase': 'FileUpload.DriverConfiguration'
                  };
            }
            return {};
          };
        const requestConfig = {
            params: { 
                selectedFileTypeName,
                snowTicketNumber,
                description,
                store
        },
            timeout: 600000, timeoutErrorMessage: "request timeout",
            headers : getHeaders(),
        }
        
        return axios.post(`${ApiPathRESE.baseUrl}/uploadFile`, data, requestConfig);
        
    }

    async getTemplateUrl(selectedFileTypeName) {
        const getHeaders = () => {
            // Conditionally return headers
            if (selectedFileTypeName === "User"){
                return {
                    'Usecase': 'FileUpload.AddUser'
                  };
            }
            else if (selectedFileTypeName === "BMS"){
                return {
                    'Usecase': 'FileUpload.AddBMS'
                  };
            }
            else if (selectedFileTypeName === "Store"){
                return {
                    'Usecase': 'FileUpload.AddBMSStore'
                  };
            }
            else if (selectedFileTypeName === "Bms Brand"){
                return {
                    'Usecase': 'FileUpload.AddBMSBrand'
                  };
            }
            return {};
          };
        const requestConfig = {
            timeout: 600000, timeoutErrorMessage: "request timeout",
            headers : getHeaders(),
        }
        const response = await axios.get(`${ApiPathRESE.baseUrl}/downloadFileTemplate`,requestConfig, { timeout: 120000, timeoutErrorMessage: "request timeout" });
        if(response.status >= 400) {
            throw new Error(response.errors);
        }
        console.log("url",response.data.data)
        return response.data.data;
        
    }

    async getReseFileuploadLogs() {
        const response = await axios.get(
            `${ApiPathRESE.baseUrl}/getFileUploadAudit`,
            { timeout: 120000, timeoutErrorMessage: "request timeout" }
        );
        if (response.status >= 400) {
            throw new Error(response.errors);
        }
        return response.data;
    }
    
}
export const getReseCustomFileNameDistinctData= async () =>  {
    const response = await axios.get(`${ApiPathRESE.baseUrl}/fetchAllDriverConfigFileNames`, { timeout: 120000, timeoutErrorMessage: "request timeout" });
    if(response.status >= 400) {
        throw new Error(response.errors);
    }
    return response.data;
}
export const getDriverConfigFileContent = async (selectedFileTypeName,store,driverConfigFileType) => {
    const getHeaders = () => {
        // Conditionally return headers
        if (selectedFileTypeName === "Driver Configuration"){
            return {
                'Usecase': 'FileUpload.DriverConfiguration'
              };
        }
        return {};
      };
    const requestConfig = {
        params: {store,driverConfigFileType},
        headers : getHeaders(),
    }
    const response = await axios.get(`${ApiPathRESE.baseUrl}/fetchDriverConfigFileContent`,requestConfig);
    if (response.status >= 400) {
        throw new Error(response.error);
    }
    return response.data;
};
export const getReseUserTableDistinctColumnData = async (columnPayload) => {
    const response = await axios.post(`${ApiPathRESE.baseUrl}/getDistinctColumnValue`, columnPayload, { timeout: 120000, timeoutErrorMessage: "request timeout" });
    if (response.status >= 400) {
        throw new Error(response.error);
    }
    return response.data;
}